// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import * as FormData from 'form-data';
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeDocumentsApi = class EdgeDocumentsApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param DocumentGroupUploadRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentDocumentGroupUpload(DocumentGroupUploadRequestModel, x_program_id) {
        const _url_ = '/edge/documents/v2/Document/documentGroupUpload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'DocumentGroupUploadRequestModel' is not null or undefined
        if (DocumentGroupUploadRequestModel === null || DocumentGroupUploadRequestModel === undefined) {
            throw new Error('Required parameter DocumentGroupUploadRequestModel was null or undefined when calling documentDocumentGroupUpload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(DocumentGroupUploadRequestModel, "DocumentGroupUploadRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentUploadResponseModel");
        }
        return response;
    }
    /**
     *
     * @param displayId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentDownload(displayId, x_program_id) {
        const _url_ = '/edge/documents/v1/Document/download/{displayId}'
            .replace('{' + 'displayId' + '}', encodeURIComponent(String(displayId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'displayId' is not null or undefined
        if (displayId === null || displayId === undefined) {
            throw new Error('Required parameter displayId was null or undefined when calling documentDownload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param displayId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentInline(displayId, x_program_id) {
        const _url_ = '/edge/documents/v1/Document/inline/{displayId}'
            .replace('{' + 'displayId' + '}', encodeURIComponent(String(displayId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'displayId' is not null or undefined
        if (displayId === null || displayId === undefined) {
            throw new Error('Required parameter displayId was null or undefined when calling documentInline.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param type
     * @param attachment
     * @param externalPartyCode
     * @param externalProgramCode
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentUpload(type, attachment, externalPartyCode, externalProgramCode, x_program_id) {
        const _url_ = '/edge/documents/v1/Document/upload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'type' is not null or undefined
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling documentUpload.');
        }
        // verify required parameter 'attachment' is not null or undefined
        if (attachment === null || attachment === undefined) {
            throw new Error('Required parameter attachment was null or undefined when calling documentUpload.');
        }
        // verify required parameter 'externalPartyCode' is not null or undefined
        if (externalPartyCode === null || externalPartyCode === undefined) {
            throw new Error('Required parameter externalPartyCode was null or undefined when calling documentUpload.');
        }
        // verify required parameter 'externalProgramCode' is not null or undefined
        if (externalProgramCode === null || externalProgramCode === undefined) {
            throw new Error('Required parameter externalProgramCode was null or undefined when calling documentUpload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let formData = new FormData();
        if (type !== undefined) {
            formData.append('type', Serializer.serialize(type, "number"));
        }
        if (attachment !== undefined) {
            formData.append('attachment', typeof attachment === 'object' && 'value' in attachment
                ? attachment.value
                : attachment, typeof attachment === 'object' && 'options' in attachment
                ? attachment.options
                : undefined);
        }
        if (externalPartyCode !== undefined) {
            formData.append('externalPartyCode', Serializer.serialize(externalPartyCode, "string"));
        }
        if (externalProgramCode !== undefined) {
            formData.append('externalProgramCode', Serializer.serialize(externalProgramCode, "string"));
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: formData,
        };
        if (formData.getHeaders) {
            Object.assign(requestConfig.headers, formData.getHeaders());
        }
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1DocumentUploadUploadResponse");
        }
        return response;
    }
    /**
     *
     * @param type
     * @param attachment
     * @param externalPartyCode
     * @param externalProgramCode
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentUpload_1(type, attachment, externalPartyCode, externalProgramCode, x_program_id) {
        const _url_ = '/edge/documents/v2/Document/upload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'type' is not null or undefined
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling documentUpload_1.');
        }
        // verify required parameter 'attachment' is not null or undefined
        if (attachment === null || attachment === undefined) {
            throw new Error('Required parameter attachment was null or undefined when calling documentUpload_1.');
        }
        // verify required parameter 'externalPartyCode' is not null or undefined
        if (externalPartyCode === null || externalPartyCode === undefined) {
            throw new Error('Required parameter externalPartyCode was null or undefined when calling documentUpload_1.');
        }
        // verify required parameter 'externalProgramCode' is not null or undefined
        if (externalProgramCode === null || externalProgramCode === undefined) {
            throw new Error('Required parameter externalProgramCode was null or undefined when calling documentUpload_1.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let formData = new FormData();
        if (type !== undefined) {
            formData.append('type', Serializer.serialize(type, "number"));
        }
        if (attachment !== undefined) {
            formData.append('attachment', typeof attachment === 'object' && 'value' in attachment
                ? attachment.value
                : attachment, typeof attachment === 'object' && 'options' in attachment
                ? attachment.options
                : undefined);
        }
        if (externalPartyCode !== undefined) {
            formData.append('externalPartyCode', Serializer.serialize(externalPartyCode, "string"));
        }
        if (externalProgramCode !== undefined) {
            formData.append('externalProgramCode', Serializer.serialize(externalProgramCode, "string"));
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: formData,
        };
        if (formData.getHeaders) {
            Object.assign(requestConfig.headers, formData.getHeaders());
        }
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentUploadResponseModel");
        }
        return response;
    }
    /**
     *
     * @param ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async fillablePdfGenerateFieldsFromFile(ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel, x_program_id) {
        const _url_ = '/edge/documents/v2/FillablePdf/generateFieldsFromFile';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel' is not null or undefined
        if (ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel === null || ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel === undefined) {
            throw new Error('Required parameter ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel was null or undefined when calling fillablePdfGenerateFieldsFromFile.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel, "ScriptsDocumentsV2FillablePdfGenerateFieldsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse");
        }
        return response;
    }
    /**
     *
     * @param ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async fillablePdfGenerateFillablePdf(ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel, x_program_id) {
        const _url_ = '/edge/documents/v2/FillablePdf/generateFillablePdf';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel' is not null or undefined
        if (ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel === null || ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel === undefined) {
            throw new Error('Required parameter ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel was null or undefined when calling fillablePdfGenerateFillablePdf.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel, "ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param GeneratePdfFromHtmlRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async generatePdfFromHtmlDownload(GeneratePdfFromHtmlRequest, x_program_id) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/download';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GeneratePdfFromHtmlRequest' is not null or undefined
        if (GeneratePdfFromHtmlRequest === null || GeneratePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter GeneratePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlDownload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(GeneratePdfFromHtmlRequest, "GeneratePdfFromHtmlRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param GeneratePdfFromHtmlRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async generatePdfFromHtmlInline(GeneratePdfFromHtmlRequest, x_program_id) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/inline';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GeneratePdfFromHtmlRequest' is not null or undefined
        if (GeneratePdfFromHtmlRequest === null || GeneratePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter GeneratePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlInline.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(GeneratePdfFromHtmlRequest, "GeneratePdfFromHtmlRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param GenerateAndSavePdfFromHtmlRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async generatePdfFromHtmlSave(GenerateAndSavePdfFromHtmlRequest, x_program_id) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromHtml/save';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GenerateAndSavePdfFromHtmlRequest' is not null or undefined
        if (GenerateAndSavePdfFromHtmlRequest === null || GenerateAndSavePdfFromHtmlRequest === undefined) {
            throw new Error('Required parameter GenerateAndSavePdfFromHtmlRequest was null or undefined when calling generatePdfFromHtmlSave.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GenerateAndSavePdfFromHtmlRequest, "GenerateAndSavePdfFromHtmlRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1GeneratePdfFromHtmlSaveSaveResponse");
        }
        return response;
    }
    /**
     *
     * @param GeneratePdfFromTemplateRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async generatePdfFromTemplateDownload(GeneratePdfFromTemplateRequest, x_program_id) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/download';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GeneratePdfFromTemplateRequest' is not null or undefined
        if (GeneratePdfFromTemplateRequest === null || GeneratePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter GeneratePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateDownload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(GeneratePdfFromTemplateRequest, "GeneratePdfFromTemplateRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param GeneratePdfFromTemplateRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async generatePdfFromTemplateInline(GeneratePdfFromTemplateRequest, x_program_id) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/inline';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GeneratePdfFromTemplateRequest' is not null or undefined
        if (GeneratePdfFromTemplateRequest === null || GeneratePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter GeneratePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateInline.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            responseType: 'arraybuffer',
            data: Serializer.serialize(GeneratePdfFromTemplateRequest, "GeneratePdfFromTemplateRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param GenerateAndSavePdfFromTemplateRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async generatePdfFromTemplateSave(GenerateAndSavePdfFromTemplateRequest, x_program_id) {
        const _url_ = '/edge/documents/v1/GeneratePdfFromTemplate/save';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GenerateAndSavePdfFromTemplateRequest' is not null or undefined
        if (GenerateAndSavePdfFromTemplateRequest === null || GenerateAndSavePdfFromTemplateRequest === undefined) {
            throw new Error('Required parameter GenerateAndSavePdfFromTemplateRequest was null or undefined when calling generatePdfFromTemplateSave.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GenerateAndSavePdfFromTemplateRequest, "GenerateAndSavePdfFromTemplateRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentsV1GeneratePdfFromTemplateSaveSaveResponse");
        }
        return response;
    }
};
EdgeDocumentsApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeDocumentsApi);
export { EdgeDocumentsApi };
//# sourceMappingURL=edgeDocumentsApi.js.map